'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _scales = require('../foundational-styles/scales');

var _scales2 = _interopRequireDefault(_scales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var overlayBackgroundColor = _scales2.default.neutral.N7A;

exports.default = overlayBackgroundColor;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy90aGVtZS9zcmMvZGVmYXVsdC10aGVtZS9jb21wb25lbnQtc3BlY2lmaWMvb3ZlcmxheUJhY2tncm91bmRDb2xvci5qcyJdLCJuYW1lcyI6WyJvdmVybGF5QmFja2dyb3VuZENvbG9yIiwic2NhbGVzIiwibmV1dHJhbCIsIk43QSJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBQUE7Ozs7OztBQUVBLElBQU1BLHlCQUF5QkMsaUJBQU9DLE9BQVAsQ0FBZUMsR0FBOUM7O2tCQUVlSCxzQiIsImZpbGUiOiJvdmVybGF5QmFja2dyb3VuZENvbG9yLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHNjYWxlcyBmcm9tICcuLi9mb3VuZGF0aW9uYWwtc3R5bGVzL3NjYWxlcydcblxuY29uc3Qgb3ZlcmxheUJhY2tncm91bmRDb2xvciA9IHNjYWxlcy5uZXV0cmFsLk43QVxuXG5leHBvcnQgZGVmYXVsdCBvdmVybGF5QmFja2dyb3VuZENvbG9yXG4iXX0=